export enum InsuranceAction {
  LINK = 'link',
  ADD = 'add',
  REJECT = 'reject',
}

export enum StepType {
  SELECT = 'select',
  CONFIRM = 'confirm',
}

export enum InsuranceRequestOption {
  LINK = 'LINK',
  ADD = 'ADD',
  REJECT = 'REJECT',
}